import React, {useEffect, useContext} from 'react'

import {useDropzone} from 'react-dropzone';
import moment from 'moment'

import StorageContext from '../../StorageContext'

const AddFileItem = ({fileArrayName, index, arrayHelpers, values, setFieldValue}) => {
    const {storage} = useContext(StorageContext);

    useEffect(() => {
        setFieldValue(`${fileArrayName}.${index}.uploadStatus`, {status: "inactive", progress: 0, error: "", message: ""});
    }, [index, setFieldValue, fileArrayName])

    const startUpload = files => {

        let oldRef = null;
        if(values[fileArrayName][index].url !== "") {
            //if there was already an file uploaded, hang on to its ref and delete it when the new file is successfully uploaded
            oldRef = values[fileArrayName][index].ref;
        }

        const refString = `downloads/${moment().format("YYYY/MM/DD")}/${files[0].name}`;
        setFieldValue(`${fileArrayName}.${index}.ref`, refString);
        setFieldValue(`${fileArrayName}.${index}.name`, files[0].name);
        setFieldValue(`${fileArrayName}.${index}.size`, files[0].size);
        setFieldValue(`${fileArrayName}.${index}.type`, files[0].type);

        const uploadTask = storage.ref().child(refString).put(files[0]);
        uploadTask.on('state_changed', snapshot => {
            const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
            setFieldValue(`${fileArrayName}.${index}.uploadStatus`, {status: "uploading", progress, error: "", message: `Uploading: ${progress}%`});
        }, error => {
            setFieldValue(`${fileArrayName}.${index}.uploadStatus`, {status: "failed", progress: 0, error, message: `Upload Failed: ${error}`});
        }, () => {
            setFieldValue(`${fileArrayName}.${index}.uploadStatus`, {status: "fetch-url", progress: 100, error: "", message: `Uploading: 100%`});
            //don't delete the file if the ref hasn't changed!
            if(oldRef && oldRef !== refString) {
                storage.ref().child(oldRef).delete().then(() => {
                    uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
                        setFieldValue(`${fileArrayName}.${index}.uploadStatus`, {status: "complete", progress: 100, error: "", message: `Upload Complete`});
                        setFieldValue(`${fileArrayName}.${index}.url`, downloadURL);
                    });
                }).catch(err => {
                    console.log("File deletion failed", err);
                })
            } else {
                uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
                    setFieldValue(`${fileArrayName}.${index}.uploadStatus`, {status: "complete", progress: 100, error: "", message: `Upload Complete`});
                    setFieldValue(`${fileArrayName}.${index}.url`, downloadURL);
                });
            }
        });
    }
    const rejectUpload = (rejections) => {
        console.log(rejections);
        setFieldValue(`${fileArrayName}.${index}.uploadStatus`, {status: "failed", progress: 0, error: rejections[0].errors[0].message, message: `Error: ${rejections[0].errors[0].message}`});
    }
    const {getRootProps, getInputProps} = useDropzone({
        maxSize: 1024000000, //1GB
        multiple: false,
        noKeyboard: true,
        preventDropOnDocument: true,
        onDropAccepted: startUpload,
        onDropRejected: rejectUpload
    });

    const remove = () => {
        if(values[fileArrayName][index].uploadStatus.status === "complete") {
            storage.ref().child(values[fileArrayName][index].ref).delete().then(() => {
                arrayHelpers.remove(index);
            }).catch(err => {
                console.log("File deletion failed", err);
            });
        } else if(values[fileArrayName][index].uploadStatus.status === "inactive" && values[fileArrayName][index].url !== "") {
            //this means that we're in edit mode, since there's no other way for an inactive file to have a valid URL
            if(window.confirm("Delete media from server?")) {
                storage.ref().child(values[fileArrayName][index].ref).delete().then(() => {
                    arrayHelpers.remove(index);
                }).catch(err => {
                    console.log("File deletion failed", err);
                });
            }
        } else {
            arrayHelpers.remove(index);
        }
    }

    if(!values[fileArrayName][index].uploadStatus) return null;

    return (
        <div key={index} className="images-item">
            <div {...getRootProps({className: 'dropzone nocaption'})}>
                <input {...getInputProps()} />
                <p>{!values[fileArrayName][index].name || values[fileArrayName][index].name === "" 
                    ? "Drag + drop a file, or click to select one" 
                    : `${values[fileArrayName][index].name} (${(values[fileArrayName][index].size / (values[fileArrayName][index].size > 1000000 ? 1000000 : 1000)).toFixed(1)} ${(values[fileArrayName][index].size > 1000000 ? "MB" : "kB")})`}
                </p>
            </div>
            <div className="upload-progress-container">
                <div className="upload-progress-bar" style={{width: `${values[fileArrayName][index].uploadStatus.progress}%`}}></div>
                <p>{values[fileArrayName][index].uploadStatus.message}</p>
            </div>
            <button 
                type="button" 
                className="cancel" 
                onClick={remove}
                disabled={values[fileArrayName][index].uploadStatus.status === "uploading"}>
                    X
            </button>
            <button 
                type="button" 
                className="up" 
                onClick={() => arrayHelpers.swap(index, index-1)}
                disabled={index === 0}>
                    ▲
            </button>
            <button 
                type="button" 
                className="down" 
                onClick={() => arrayHelpers.swap(index, index+1)}
                disabled={index === values[fileArrayName].length - 1} >
                    ▼
            </button>
        </div>
    )
}

export default AddFileItem;